import React, { useState } from 'react';
import { B2BSidebar } from './Sidebar/B2BSidebar';
import { Topbar } from './Topbar/Topbar';
import { MobileDrawer } from './MobileDrawer/MobileDrawer';
import { MobileBottomNav } from './MobileBottomNav';

interface B2BLayoutProps {
  children: React.ReactNode;
}

export const B2BLayout: React.FC<B2BLayoutProps> = ({ children }) => {
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  const handleMenuClick = () => {
    setMobileDrawerOpen((prev) => !prev);
  };

  return (
    <div className="relative flex h-screen bg-background overflow-hidden">
      {/* ---------- Desktop Sidebar (Overlayed) ---------- */}
      <div className="hidden lg:block fixed left-0 top-0 h-screen z-40">
        <B2BSidebar />
      </div>

      {/* ---------- Main Content ---------- */}
      <div className="flex-1 flex flex-col min-w-0 lg:ml-20 transition-all duration-300">
        {/* Topbar (normal, scrolls with content) */}
        <Topbar onMenuClick={handleMenuClick} />

        {/* Main scrollable area */}
        <main className="flex-1 overflow-auto pb-16 lg:pb-0 lg:px-6 transition-all duration-300">
          {children}
        </main>

        {/* Mobile Bottom Navigation - can customize for B2B later */}
        <MobileBottomNav
          onMenuClick={handleMenuClick}
          isMenuOpen={mobileDrawerOpen}
        />
      </div>

      {/* ---------- Mobile Drawer - can customize for B2B later ---------- */}
      <MobileDrawer
        open={mobileDrawerOpen}
        onOpenChange={setMobileDrawerOpen}
      />
    </div>
  );
};
